<div class="ancillary-price">
  <span class="heather-700-text text-icon-primary bold-type font-heading-2 font-headline-medium">{{
    price | finPrice
  }}</span>
  <span class="pr-xsmall-l nordic-blue-900-text text-icon-primary font-body-1 font-body-medium">{{
    title | finLocalization
  }}</span>
</div>
<div class="ancillary-price-info font-body-1 nordic-blue-900-text text-icon-primary pr-medium-b font-body-medium">
  {{ disclaimer | finLocalization }}
</div>
